import React, { useRef, useEffect, useCallback, useState} from 'react';
import PianoSlider from './PianoSlider.js';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {chop} from "pattern/utils/chop.js";
import {connect} from 'react-redux';

const PianoChopper = ({clear, track, selectedSteps}) => { 
    let originalStep = useRef(selectedSteps[0] && selectedSteps[0].getCopy(true));
    let mutations = useRef(undefined);
    let stepNumber = useRef(0);
    let duration = useRef(1);

    let [chops, setChops] = useState(1);

    useEffect(() => {
        if (!originalStep.current) { return; }
        stepNumber.current = track.getEasyPattern().findStepNumber(originalStep.current, undefined, true);
        duration.current = originalStep.current.duration;
    }, []);

    const onChange = useCallback((e) => {
        let _chops = e.target.value;
        let _mutations = mutations.current || [originalStep.current];
        mutations.current = chop(track, _mutations, stepNumber.current, duration.current, _chops);
        setChops(_chops);
    }, [track, setChops]);

    return (
        <PianoSlider
          step={1}
          min={1}
          max={32}
          name="Chops"
          value={chops}
          onChange={onChange}/>
   );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoChopper);
